import { MODAL_NAMES } from '~/scopes/product-core/constants'

export const OBSOLETE_BLOCK_TYPES: Record<string, string> = {
  software_obsolete: MODAL_NAMES.OBSOLETE_SOFTWARE,
  new_os_installed: MODAL_NAMES.OBSOLETE_COMPUTER,
}
